import arrayMove from './arrayMove';

export const moveItem = (array: any[], field: any, itemId: any, position: number): any[] => {
  const element = array.find((el) => el[field] === itemId);
  const fromIndex = element ? array.indexOf(element) : -1; //TODO: What is the best way to handle this, since element could be undefined?

  if (fromIndex + position < 0 || fromIndex + position === array.length) {
    return array;
  }
  return arrayMove(array, fromIndex, fromIndex + position);
};

export const moveItemByIndex = (array: any[], index: number, position: number): any[] => {
  if (index + position < 0 || index + position === array.length) {
    return array;
  }
  return arrayMove(array, index, index + position);
};
